module.exports = __webpack_public_path__ + "static/img/scientist.1cf4bb69.png";